import React from "react";
import moment from "moment";

import Context from "../../../context/Context";
import Icons from "../../util/Icons";
import ModalController from "../../../common/components/Modal/ModalController";
import Popover from "calcite-react/Popover"
import SDPWrapper from "../../../components/common/Calendar/SDPWrapper";
import Topic from "../../../context/Topic";
import UIMode from "../../../context/UIMode";
import * as component from "../../util/component";
import * as dateUtil from "../Events/dateUtil";
import * as ics from "../Events/ics";

//import CalIcon from "calcite-ui-icons-react/CalendarIcon";
import ClockIcon from "calcite-ui-icons-react/ClockIcon";
import PinIcon from "calcite-ui-icons-react/PinIcon";
import UserIcon from "calcite-ui-icons-react/UserIcon";
import { makeEventInfo } from "../../../util/calendarUtil";
import CalendarSelector from "../../../util/CalendarSelector";
import { isNetworkError } from "../../../util/networkUtil";
import { getHotelBookingSystem, getHotelBookingSystemType, getMeetingBookingSystem, getMeetingBookingSystemType } from "../More/Actions/BookWorkspace/WorkspaceReservation/workspaceReservationUtil";
import CheckInOutPicker from "./CheckInOutPicker";

const CSS = {
  dateLabel: "i-date-label",
  dayLabel: "i-day-label",
  labelGroup: "i-label-group"
};

export default class Schedule extends React.Component {

  componentId;
  _mounted = false;

  constructor(props) {
    super(props);
    this.componentId = component.nextId("schedule-");
    let dateMoment = moment(new Date());
    if (this.props.start)
      dateMoment = moment(this.props.start);

    let isWeekly = true;
    const mode = Context.instance.uiMode.mode;
    if (mode === UIMode.MODE_HORIZONTAL_SPLIT) {
      isWeekly = false;
    } else if (mode === UIMode.MODE_VERTICAL_SPLIT) {
      isWeekly = false;
    }

    const targetWhen = JSON.parse(JSON.stringify(this.props.when));

    this.state = component.newState({
      considerScrollIntoView: null,
      isWeekly: isWeekly,
      isWorking: true,
      reservationInfo: null,
      dateMoment: dateMoment,
      calendarOpen: false,
      startOfWeekMillis: moment(dateMoment.valueOf()).startOf("week").valueOf(),
      when: targetWhen,
    });
  }

  bookClicked = () => {    
    let when = this.state.when;
    let duration = when.duration === "allDay" ? when.duration : dateUtil.determineDurationKey(when);
    const selectedWhen = {
      duration: duration,
      start: { date: when.start.date },
      end: { date: when.end.date },
      isOngoingBooking: this.props.isOngoingBooking,
      originalReservation: this.props.originalReservation,
    };
    this.props.onBookClicked && this.props.onBookClicked(selectedWhen);
  }

  // bookClicked = (dtStart) => {
  //   const item = this.props.item;
  //   const bookItem = {
  //     name: item.name,
  //     unitId: item.unitId,
  //     feature: item.unitFeature
  //   }
  //   let duration = "oneHour";
  //   let dtEnd = dateUtil.addDuration(dtStart,duration);
  //   let criteria = {
  //     when: {
  //       duration: duration,
  //       start: {date: dtStart.getTime()},
  //       end: {date: dtEnd.getTime()}
  //     },
  //   };
  //   if (this.props.onBookClicked) {
  //     this.props.onBookClicked({
  //       when: criteria.when
  //     });
  //   } else {
  //     Book.show(bookItem,criteria);
  //   }
  // }

  componentDidMount() {
    this._mounted = true;
    this.queryUnitSchedule();
    if (this.props.onMount) this.props.onMount(this);

    component.own(this, [
      Topic.subscribe(Topic.ReservationsUpdated,params => {
        this.setState({
          daysWithReservations: null,
          daysWithMonthsQueried: null
        }, () => {
          this.queryUnitSchedule();
        });
      }),

      Topic.subscribe(Topic.UIModeSet, params => {
        component.refresh(this);
      })
    ]);
  }

  componentDidUpdate() {
    if (this.state.considerScrollIntoView) {
      this.scrollIntoView();
      this.setState(state => {
        return {
          considerScrollIntoView: false
        };
      });
    }
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
    this._mounted = false;
  }

  makeIcsInfo(reservation) {
    const i18n = Context.instance.i18n;
    let feature = this.props.item.unitFeature;
    let filename = "reservation.ics";
    let info = {
      name: reservation.title,
      description: reservation.description,
      location: reservation.unitName,
      date_start: new Date(reservation.fromDate),
      date_end: new Date(reservation.toDate),
      geo: null,
      geometry: feature && feature.geometry
    };
    if (this.props.item.isHotel) {
      const locationUrl = this.props.item.locationUrl;
      info.name = i18n.more.bookWorkspace.emailSubject.replace("{workspaceName}", reservation.unitName);
      if (locationUrl) {
        info.description = `${i18n.more.bookWorkspace.locationLinkPattern} - ${locationUrl}`;
      }
    }
    ics.makeIcsInfo(info,filename).then(icsInfo => {
      reservation.icsInfo = icsInfo;
    }).catch(ex => {
      console.error("Error generating .ics file:",ex);
    });
  }

  queryDaysWithReservations(m) {
    if (!m || (typeof m.valueOf !== "function")) return;
    let millis = m.valueOf();
    let fromDate = moment(millis).startOf("month").toDate();
    let toDate = moment(fromDate).add(1,"month").endOf("month").toDate();
    let r = Context.instance.aiim.datasets && Context.instance.aiim.datasets.reservations;
    let unitId = this.props.item.unitId;
    let mq = this.state.daysWithMonthsQueried;
    if (mq) {
      let hasFrom = mq.has(moment(fromDate).format("YYYY-MM"));
      let hasTo = mq.has(moment(toDate).format("YYYY-MM"));
      if (hasFrom && hasTo) return;
    }
    let promise = this._daysPromise = this.getMonthQueryPromise(m);
    promise.then(reservationInfo => {
      if (!this._mounted) return;
      if (promise !== this._daysPromise) return;
      //console.log("queryDaysWithReservations.info",reservationInfo)
      this._daysPromise = null;
      let dw = this.state.daysWithReservations;
      let dwmq = this.state.daysWithMonthsQueried;
      let daysWith = null;
      if (reservationInfo && reservationInfo.reserved) {
        if (!daysWith) daysWith = new Set(dw);
        reservationInfo.reserved.forEach(r => {
          if (r.fromDate) daysWith.add(moment(r.fromDate).format("YYYY-MM-DD"));
          if (r.toDate) daysWith.add(moment(r.toDate).subtract(1, "second").format("YYYY-MM-DD"));
        });
        let monthsQueried = new Set(dwmq);
        monthsQueried.add(moment(fromDate).format("YYYY-MM"));
        monthsQueried.add(moment(toDate).format("YYYY-MM"))
        //console.log("monthsQueried",monthsQueried)
        this.setState({
          daysWithReservations: daysWith,
          daysWithMonthsQueried: monthsQueried
        });
      }

    }).catch(ex => {
      console.error(ex);
      if (!this._mounted) return;
      //Topic.publishErrorAccessingData();
    });
  }

  getMonthQueryPromise(ms) {
    const reservations = Context.instance.aiim.datasets && Context.instance.aiim.datasets.reservations;
    let bookingSystem;
    if(this.props.bookingType === "hotel") {
      bookingSystem = getHotelBookingSystem()
    } else {
      bookingSystem = getMeetingBookingSystem();
    }
    const millis = ms.valueOf();
    const { item } = this.props;
    const unitId = item.unitId;

    if (reservations) {
      const fromDate = moment(millis).startOf("month").toDate();
      const toDate = moment(fromDate).add(1, "month").endOf("month").toDate();
      return reservations.queryUnitSchedule(unitId, fromDate, toDate);
    } else if (bookingSystem.type === "office365") {
      const fromDate = {
        dateTime: moment(millis).startOf("month").toDate(),
        timeZone: "UTC"
      };
      const toDate = {
        dateTime: moment(fromDate).add(1, "month").endOf("month").toDate(),
        timeZone: "UTC"
      };
      return bookingSystem.queryUnitSchedule(item, fromDate, toDate);
    }

    return Promise.resolve(null);
  }

  queryUnitSchedule() {
    let type, bookingSystem;
    if(this.props.bookingType === "hotel") {
      type = getHotelBookingSystemType();
      bookingSystem = getHotelBookingSystem()
    } else {
      type = getMeetingBookingSystemType();
      bookingSystem = getMeetingBookingSystem();
    }
    if (type === "esri") {
      this.queryReservationUnitSchedule(bookingSystem);
    } else if (type === "office365") {
      this.queryOffice365UnitSchedule(bookingSystem);
    }
  }

  queryReservationUnitSchedule(bookingSystem) {
    let fromDate = new Date(this.state.startOfWeekMillis);
    let toDate = moment(fromDate).endOf("week").toDate();
    let r = Context.instance.aiim.datasets.reservations;
    let unitId = this.props.item.unitId;
    let promise = this._promise = r.queryUnitSchedule(unitId,fromDate,toDate);
    promise.then(reservationInfo => {
      if (!this._mounted) return;
      if (promise !== this._promise) return;
      this._promise = null;
      if (reservationInfo && reservationInfo.reserved) {
        reservationInfo.reserved.forEach(r => {
          this.makeIcsInfo(r);
        });
      }
      let considerScrollIntoView = false;
      if (this.state.considerScrollIntoView === null && this.state.isWeekly) {
        considerScrollIntoView = true;
      }
      this.setState({
        considerScrollIntoView: considerScrollIntoView,
        isWorking: false,
        reservationInfo: reservationInfo
      }, () => {
        this.queryDaysWithReservations(moment(fromDate));
      });
    }).catch(ex => {
      console.error(ex);
      if (!this._mounted) return;
      this.setState({isWorking: false});

      if (ex && isNetworkError(ex.message)) {
        const i18n = Context.getInstance().i18n;
        Topic.publishNetworkError(i18n.meetingRooms.issues.m5);
      } else {
        Topic.publishErrorAccessingData();
      }
    });
  }

  async queryOffice365UnitSchedule(bookingSystem) {
    const { item } = this.props;
    if (bookingSystem.type !== "office365") {
      return;
    }

    const fromDate = {
      dateTime: new Date(this.state.startOfWeekMillis),
      timeZone: "UTC"
    };
    const toDate = {
      dateTime: moment(fromDate.dateTime).endOf("week").toDate(),
      timeZone: "UTC"
    };

    try {
      if (!this._mounted) {
        return;
      }
      const reservationInfo = await bookingSystem.queryUnitSchedule(item, fromDate, toDate);
      const considerScrollIntoView = this.state.considerScrollIntoView === null && this.state.isWeekly;
      this.setState({
        considerScrollIntoView: considerScrollIntoView,
        isWorking: false,
        reservationInfo: reservationInfo
      }, () => {
        this.queryDaysWithReservations(moment(fromDate.dateTime));
      });
    } catch (e) {
      console.error(e);
    }
  }

  render() {
    const isDaily = !this.state.isWeekly;
    const style = {
      display: "flex",
      flexDirection: "column",
    }
    if (isDaily) {
      style.alignItems = "center";
    }
    return (
      <div style={style}>
        {this.renderCheckInOut()}
        {this.renderHeader()}
        {this.renderSchedule()}
      </div>
    );
  }

  renderCheckInOut() {
    const i18n = Context.getInstance().i18n;
    const { when, isWeekly } = this.state;
    const viewType = isWeekly ? "horizontal" : "vertical";
    let isOngoingBooking;

    if(this.props && this.props.operation === "updateBookingTime") {
      isOngoingBooking = this.props.isOngoingBooking;
      if(isOngoingBooking) when.duration = null;
    }

    return (
      <div className="i-check-in-out-header">
        <CheckInOutPicker 
          operation={this.props.operation}
          bookingType={this.props && this.props.bookingType}
          isOngoingBooking={isOngoingBooking}
          when={when}
          duration={when.duration}
          start={when.start.date}
          end={when.end.date}
          viewType={viewType} 
          size={"small"} 
          onDateChanged={this._onCheckInOutChanged}
        />
        <button className="i-button" onClick={this.bookClicked}>{
          this.props.operation === "updateBookingTime" ? i18n.general.update : i18n.meetingRooms.book.label
        }</button>
      </div>
    );
  }

  renderDatePicker() {
    const i18n = Context.instance.i18n;
    const lib = Context.instance.lib;
    const ariaLabel = i18n.meetingRooms.dateAriaLabel;
    const dateMoment = this.state.dateMoment;
    const isOpen = !!this.state.calendarOpen;
    const calendarIcon = "libs/calcite-ui-icons/icons/sprite-16.svg#calendar-16";
    let s;
    if (dateMoment) {
      try {
        s = lib.dojo.locale.format(dateMoment.toDate(),{selector:"date",formatLength:"short"});
      } catch (ex) {
        console.log("badDateMoment",dateMoment)
        console.error(ex);
      }
    }

    const isOutsideRange = (day) => {
      //return moment().isAfter(day, 'day')
      return false;
    }
    const isDayHighlighted = (day) => {
      let daysWith = this.state.daysWithReservations;
      if (daysWith) {
        return daysWith.has(day.format("YYYY-MM-DD"))
      }
      return false;
    }

    const clicked = () => {
      this.setState({
        calendarOpen: !this.state.calendarOpen
      })
    }

    const changed = (date) => {
      if (date !== null && date !== undefined) {
        let dtMoment = moment(date);
        let v = moment(date).startOf("week").valueOf();
        this.setState({
          startOfWeekMillis: v,
          dateMoment: dtMoment,
          calendarOpen: false
        }, () => this.queryUnitSchedule());
      }
    }

    const close = () => {
      this.setState({
        calendarOpen: false
      })
    }

    const button = (
      <button aria-label={ariaLabel} className="i-date"
        onClick={clicked}>
        <div className="i-sidebar-icon-container i-filter-container">
          {/* <div className="i-date-string">{s}</div> */}
          <svg className="i-more-menu-icon"><use href={calendarIcon}></use></svg>
        </div>
      </button>
    );

    return (
      <Popover
        closeOnSelect={false}
        onRequestClose={close}
        open={isOpen}
        targetEl={button}
        appendToBody>
        <SDPWrapper
          initialDate={dateMoment}
          outsideRange={isOutsideRange}
          dayHighlighted={isDayHighlighted}
          booking={true}
          onDateChange={changed}
          forSchedule={true}
          onPrevMonthClick={m => {
            if (m) {
              this.queryDaysWithReservations(m);
            }
          }}
          onNextMonthClick={m => {
            if (m) {
              this.queryDaysWithReservations(m);
            }
          }}
        />
      </Popover>
    );
  }

  renderHeader() {
    const i18n = Context.instance.i18n;
    const startOfWeekMillis = this.state.startOfWeekMillis;
    const isWeekly = this.state.isWeekly;
    const isDaily = !isWeekly;

    const today = () => {
      let now = Date.now();
      let v = moment(now).startOf("week").valueOf();
      this.setState({
        calendarOpen: false,
        startOfWeekMillis: v,
        dateMoment: moment(now).startOf("day")
      }, () => this.queryUnitSchedule());
    };
    const prev = () => {
      let v = moment(startOfWeekMillis).add(-1,"week").startOf("week").valueOf();
      this.setState({
        calendarOpen: false,
        startOfWeekMillis: v,
        dateMoment: moment(v)
      }, () => this.queryUnitSchedule());
    };
    const next = () => {
      let v = moment(startOfWeekMillis).add(1,"week").startOf("week").valueOf();
      this.setState({
        calendarOpen: false,
        startOfWeekMillis: v,
        dateMoment: moment(v)
      }, () => this.queryUnitSchedule());
    };
    const prevDay = () => {
      let v = moment(this.state.dateMoment.valueOf()).add(-1,"day").valueOf();
      this.setState({
        calendarOpen: false,
        startOfWeekMillis: moment(v).startOf("week").valueOf(),
        dateMoment: moment(v).startOf("day")
      }, () => this.queryUnitSchedule());
    };
    const nextDay = () => {
      let v = moment(this.state.dateMoment.valueOf()).add(1,"day").valueOf();
      this.setState({
        calendarOpen: false,
        startOfWeekMillis: moment(v).startOf("week").valueOf(),
        dateMoment: moment(v).startOf("day")
      }, () => this.queryUnitSchedule());
    };

    let leftIcon = Icons.left();
    let rightIcon = Icons.right();
    if (Context.instance.uiMode.isRtl) {
      let tmp = leftIcon;
      leftIcon = rightIcon;
      rightIcon= tmp;
    }

    const when = this.state.when;
    let whenNode;
    if (when) {
      // let lib = Context.instance.lib;
      // let dtFrom = new Date(when.start.date);
      // let dtTo = new Date(when.end.date);
      // let from = lib.dojo.locale.format(dtFrom,{formatLength:"short"});
      // let to = lib.dojo.locale.format(dtTo,{formatLength:"short"});

      // let range = i18n.meetingRooms.rangePattern.replace("{fromDate}",from).replace("{toDate}",to);
      const range = this._makeRangeLabel();
      whenNode = (
        <div
           style={{
             display: "flex",
             alignItems: "center"
           }}>
          <span className="i-separated-left-right date-label">{range}</span>
        </div>
      )
    }

    if (isDaily) {
      return (
        <div className="i-schedule-header">
          <div className="i-flex-between"
            style={{alignItems:"center", marginBottom:"20px"}}>
            <div style={{display: "flex",alignItems:"center"}}>
              <button className="i-button-gray"
                style={{margin:"0rem 4px 0 4px", minHeight: "2rem"}}
                onClick={prevDay}
                aria-label={i18n.meetingRooms.schedule.previousDayAriaLabel}
                title={i18n.meetingRooms.schedule.previousDay}
              >{leftIcon}</button>
              <div>
                <button className="i-button-gray"
                  style={{margin:"0.2rem 4px 0 4px", minHeight: "2rem"}}
                  onClick={today}
                  aria-label={i18n.meetingRooms.schedule.todayAriaLabel}
                >{i18n.meetingRooms.schedule.today}</button>
              </div>
              <div className="i-duration-group i--daily"
                style={{margin:"0px", minHeight: "2rem"}}>
                {this.renderDatePicker()}
              </div>
              <button className="i-button-gray"
                style={{margin:"0rem 4px 0 4px", minHeight: "2rem"}}
                onClick={nextDay}
                aria-label={i18n.meetingRooms.schedule.nextDayAriaLabel}
                title={i18n.meetingRooms.schedule.nextDay}
              >{rightIcon}</button>
            </div>
          </div>
          <div>
            {whenNode}
          </div>
        </div>
      );
    }

    if (isWeekly) {
      return (
        <div className="i-schedule-header i-flex-between"
          style={{alignItems:"center", margin:"10px 0"}}>
          <div
            style={{
              whiteSpace:"nowrap",
              display: "flex",
              alignItems: "center"
            }}>
            <div style={{whiteSpace:"nowrap", display: "flex"}}>
              <button className="i-button-gray"
                onClick={prev}
                aria-label={i18n.meetingRooms.schedule.previousWeekAriaLabel}
                title={i18n.meetingRooms.schedule.previousWeek}
              >{leftIcon}</button>
              {/* <span style={{whiteSpace:"nowrap", margin:"4px"}}
              >{i18n.meetingRooms.schedule.week}</span> */}
              <div>
                <button className="i-button-gray"
                  style={{margin:"0.2rem 4px 0 4px", minHeight: "2rem"}}
                  onClick={today}
                  aria-label={i18n.meetingRooms.schedule.todayAriaLabel}
                >{i18n.meetingRooms.schedule.today}</button>
              </div>
              <div className="i-duration-group" style={{margin:"0px", minHeight: "2rem"}}>
                {this.renderDatePicker()}
              </div>
              <button className="i-button-gray"
                onClick={next}
                aria-label={i18n.meetingRooms.schedule.nextWeekAriaLabel}
                title={i18n.meetingRooms.schedule.nextWeek}
              >{rightIcon}</button>
            </div>
          </div>
          {whenNode}
        </div>
      );
    }

  }

  renderSchedule() {

    const now = Date.now();
    const nowOffset = now - moment(now).startOf("day").valueOf();
    const hfmt = dateUtil.getMomentHourFormat(false);
    const reservationInfo = this.state.reservationInfo;
    const startOfWeekMillis = this.state.startOfWeekMillis;
    const isWeekly = this.state.isWeekly;
    const isDaily = !isWeekly;
    const isHotel = !!this.props.item.isHotel;
    const dragInfo = {};
    const isOngoing = !!(this.props.operation === "updateBookingTime" && this.props.isOngoingBooking);

    let pixelHeightPerHour = 40;
    let pixelWidthPerDay = 100;
    let pixelHeightPerDay = 24 * pixelHeightPerHour;
    let dayLabelHeight = 0;
    let hourLabelWidth = 60;
    let hourLabelAlign = "left";
    let minPanelWidth = (pixelWidthPerDay * 7) + hourLabelWidth + 20;
    let contentTop = 45;
    let contentHeight = "260px";
    let minPanelHeight = 300;
    let maxContentWidth = "none";
    let dragHandleSize = 16;
    let dragHandleHalfSize = 8;
    let shouldScroll = true;

    let lineColor = "#e8e8e8";
    let lineColorNow = "#005e95";
    let backgroundColor = "#f6f6f6";
    let dayBorder = "1px solid "+lineColor;
    //let busyBackgroundColor = "#d3d3d3";
    let busyTextColor = "var(--i-theme-color-brand-text)";
    let busyBackgroundColor = "var(--i-theme-color-brand)";
    let busyBorder = "1px solid var(--i-theme-color-border)";

    let whenTextColor = "var(--i-theme-color-brand-text)";
    let whenBackgroundColor = "lightgreen";
    let whenBorder = "1px solid darkgreen";

    let dragHandleColor = "transparent";

    let lrProp = "left";
    if (Context.instance.uiMode.isRtl) {
      lrProp = "right";
      hourLabelAlign = "right";
    }

    let millisDay1Start = startOfWeekMillis;
    let millisPerDay = (1000 * 60 * 60 * 24);

    if (isDaily) {
      let v = this.state.dateMoment.valueOf();
      millisDay1Start = moment(v).startOf("day").valueOf();
      dayLabelHeight = 0;
      pixelWidthPerDay = 240;
      if (Context.instance.uiMode.mode === UIMode.MODE_VERTICAL_SPLIT) {
        pixelWidthPerDay = 180;
      }
      contentTop = 0;
      contentHeight = "300px";
      minPanelWidth = (pixelWidthPerDay * 1) + hourLabelWidth + 20;
      maxContentWidth = minPanelWidth+"px";
    }

    let getTop = ((dt,millisStart,millisEnd) => {
      let t = dt.getTime();
      if (t < millisStart) t = millisStart;
      if (t > millisEnd) t = millisEnd;
      let top = ((t - millisStart) / millisPerDay) * pixelHeightPerDay;
      return top + dayLabelHeight;
    });

    // let doubleClicked = (evt,d) => {
    //   evt.stopPropagation();
    //   let rect, target = evt && evt.target;
    //   if (target && target.getAttribute("data-i-day") === "y") {
    //     rect = target.getBoundingClientRect();
    //   }
    //   if (!rect) return;
    //   let y = evt.clientY - rect.top;
    //   let millis = (y / pixelHeightPerDay) * millisPerDay;
    //   let m = moment(millisDay1Start).add(d,"day").startOf("day").add(millis,"milliseconds");
    //   let prev = moment(m.toDate()).startOf("hour").valueOf();
    //   let next = moment(prev).add(1,"hour");
    //   let vmillis = prev;
    //   if (prev > Date.now()) {
    //     reservationInfo.reserved.some(r => {
    //       if ((r.toDate > prev) && (r.toDate < next)) {
    //         vmillis = next;
    //         return true;
    //       }
    //       return false;
    //     });
    //   }
    //   console.log("doubleClicked date",evt.clientY,m.toDate())
    //   if (vmillis > Date.now()) {
    //     if (this.props.onTimeClicked) {
    //       this.props.onTimeClicked(m,vmillis);
    //     } else {
    //       this.bookClicked(new Date(vmillis));
    //     }
    //   }
    // };

    let singleClick = (evt,d) => {
      evt.stopPropagation();
      if (isOngoing) return;
      let rect, target = evt && evt.target;
      if (target && target.getAttribute("data-i-day") === "y") {
        rect = target.getBoundingClientRect();
      }
      if (!rect) return;
      let y = evt.clientY - rect.top;
      let millis = (y / pixelHeightPerDay) * millisPerDay;
      let m = moment(millisDay1Start).add(d,"day").startOf("day").add(millis,"milliseconds");
      let prev = moment(m.toDate()).startOf("hour").valueOf();
      let next = moment(prev).add(1,"hour").valueOf();
      let vmillis = prev;
      if (prev > Date.now()) {
        reservationInfo.reserved.some(r => {
          if ((r.toDate > prev) && (r.toDate < next)) {
            vmillis = next;
            return true;
          }
          return false;
        });
      }
      //console.log("singleClick date",evt.clientY,m.toDate())
      if (vmillis > Date.now()) {
        let dtEnd = dateUtil.addDuration(new Date(vmillis),"oneHour");
        let when = this.state.when;
        when.duration = null;
        when.start.date = vmillis;
        when.end.date = dtEnd.getTime();
        component.refresh(this);
      }
    };

    let drag = (evt,d) => {
      evt.preventDefault();
      let elWhen = document.getElementById(this.componentId+"when-"+d);
      let rectWhen = elWhen && elWhen.getBoundingClientRect();
      let elDay = document.getElementById(this.componentId+"day-"+d);
      let rectDay = elDay && elDay.getBoundingClientRect();
      if (!rectWhen || !rectDay) return;

      let resize = true;
      if (dragInfo.pos === "bottom") {
        let h = evt.clientY - rectWhen.top;
        if (h < rectWhen.height) {
          // don't resize when dragging from the bottom up
          resize = false;
          // let cur = Date.now();
          // if ((cur - dragInfo.lastResize) > 1000) {
          //   resize = true;
          // }
          // if (resize) dragInfo.lastResize = cur;
        }
      }

      const scroll = () => {
        if (elDay && elDay.scrollTop === "function") elDay.scrollTop(evt.clientY);
        shouldScroll = true;
      }

      let x = evt.clientX;
      let minX = rectDay.x;
      let maxX = rectDay.x + rectDay.width;
      if (x < minX || x > maxX) return;

      if (dragInfo.pos === "top") {
        let t = evt.clientY - rectDay.top + dayLabelHeight;
        let h = rectWhen.height + (rectWhen.top - evt.clientY);
        if (resize) elWhen.style.top = (t+dragHandleHalfSize)+"px";
        if (resize) elWhen.style.height = (h-dragHandleHalfSize)+"px";
        if (h > dragInfo.initialHeight && shouldScroll) {
          shouldScroll = false;
          setTimeout(scroll, 10);
        }
      } else if (dragInfo.pos === "bottom") {
        let h = evt.clientY - rectWhen.top;
        if (resize) elWhen.style.height = h+"px";
        if (h > dragInfo.initialHeight && shouldScroll) {
          shouldScroll = false;
          setTimeout(scroll, 10);
        }
      }
    }

    let dragEnd = (evt,d) => {
      let elWhen = document.getElementById(this.componentId+"when-"+d);
      if (elWhen) {
        let it = dragInfo.initialTop;
        let ih = dragInfo.initialHeight;
        if (typeof it === "number") elWhen.style.top = it+"px";
        if (typeof ih === "number") elWhen.style.height = ih+"px";
      }
      dragInfo.activeDay = null;
      dragInfo.initialTop = null;
      dragInfo.initialHeight = null;
      dragInfo.pos = null;
      component.refresh(this);
    }

    let drop = (evt,d) => {
      evt.preventDefault();
      let elWhen = document.getElementById(this.componentId+"when-"+d);
      let rectWhen = elWhen && elWhen.getBoundingClientRect();
      let elDay = document.getElementById(this.componentId+"day-"+d);
      let rectDay = elDay && elDay.getBoundingClientRect();

      if (!rectWhen || !rectDay) {
        component.refresh(this);
        return;
      }
      let y = evt.clientY - rectDay.top;

      let millis = (y / pixelHeightPerDay) * millisPerDay;
      let mDayStart = moment(millisDay1Start).add(d,"day").startOf("day");
      let millisDayStart = mDayStart.valueOf();
      let millisDayEnd = moment(millisDayStart).endOf("day").valueOf();
      let m = moment(millisDay1Start).add(d,"day").startOf("day").add(millis,"milliseconds");
      let prev = moment(m.toDate()).startOf("hour").valueOf();
      let next = moment(prev).add(1,"hour").valueOf();

      // Allow resizing the calendar selection to 30 minutes duration #4559
      let half = moment(prev).add(30,"minutes").valueOf();
      let mcur = m.valueOf();
      let d1 = Math.abs(prev - mcur);
      let d2 = Math.abs(half - mcur);
      let d3 = Math.abs(next - mcur);
      let snapped = prev;
      if ((d1 < d2) && (d1 < d3)) {
        snapped = prev;
      } else if ((d2 < d1) && (d2 < d3)) {
        snapped = half;
      } else if ((d3 < d1) && (d3 < d2)) {
        snapped = next;
      }

      let when = this.state.when;
      if (dragInfo.pos === "top") {
        let vmillis = snapped;
        if (vmillis < millisDayStart) vmillis = millisDayStart;
        if (vmillis !== dragInfo.r.fromDate && vmillis < dragInfo.r.toDate) {
          when.start.date = vmillis;
          dragInfo.initialTop = null;
          dragInfo.initialHeight = null;
          component.refresh(this);
        } else {
          dragEnd(evt,d);
        }
      } else if (dragInfo.pos === "bottom") {
        let vmillis = snapped;
        if (vmillis > millisDayEnd) vmillis = millisDayEnd;
        if (vmillis !== dragInfo.r.toDate && vmillis > dragInfo.r.fromDate) {
          when.end.date = vmillis;
          dragInfo.initialTop = null;
          dragInfo.initialHeight = null;
          component.refresh(this);
        } else {
          dragEnd(evt,d);
        }
      }
    }

    let rclicked = (evt,d,r) => {
      evt.stopPropagation();
      let target = evt && evt.target;
      if (target && target.getAttribute("data-i-res") === "y") {
        this.showMeetingInfo(r);
      }
    };

    let wclicked = (evt,d,r) => {
      evt.stopPropagation();
    };

    let dayLabels = [];
    if (isWeekly) {
      for (let d=0;d<7;d++) {
        const now = moment();
        let mDay = moment(millisDay1Start).add(d,"day");
        const isToday = now.isSame(mDay, 'day');
        let offsetLR = hourLabelWidth;
        let lrVal = offsetLR + (pixelWidthPerDay * d);
        let top = 0;
        const clsDate = isToday ? `${CSS.dateLabel} today` : CSS.dateLabel;
        const clsDay = isToday ? `${CSS.dayLabel} today` : CSS.dayLabel;
        let lbl = (
          <div className={CSS.labelGroup}>
            <div className={clsDate} style={{fontSize:"12px"}}>{mDay.date()}</div>
            <div className={clsDay} style={{fontSize:"12px"}}>{mDay.format("dddd")}</div>
          </div>
        )
        let nd = (
          <div key={"dl"+mDay.valueOf()}
            style={{
              fontSize: "12px",
              position: "absolute",
              [lrProp]: lrVal+"px",
              top: top+"px",
              width: pixelWidthPerDay+"px",
              height: "60px",
              lineHeight: "1rem",
              textAlign: "center",
              overflow: "hidden"
            }}
          >{lbl}</div>
        );
        dayLabels.push(nd);
      }
    }

    let hourLabels = [];
    for (let h=0;h<24;h++) {
      let m = moment(new Date(millisDay1Start)).add(h,"hour");
      let lbl = m.format(hfmt);
      let top = h * pixelHeightPerHour + dayLabelHeight;
      let lrVal = 0;
      let nd = (
        <div key={"hl"+m.valueOf()}
          style={{
            fontSize: "12px",
            marginTop: "-10px",
            position: "absolute",
            [lrProp]: lrVal+"px",
            top: top+"px",
            width: hourLabelWidth+"px",
            textAlign: hourLabelAlign,
            overflow: "hidden"
          }}
        >{lbl}</div>
      );
      hourLabels.push(nd);
    };

    let days = [], separators = [], nowLine = [];
    for (let d=0;d<7;d++) {
      if (isDaily && d > 0) break;
      let mDayStart = moment(millisDay1Start).add(d,"day").startOf("day");
      let millisDayStart = mDayStart.valueOf();
      let offsetLR = hourLabelWidth;
      let lrVal = offsetLR + (pixelWidthPerDay * d);
      let nd = (
        <div id={this.componentId+"day-"+d}
          key={"d"+millisDayStart}
          role="button"
          tabIndex="0"
          data-i-day="y"
          onKeyDown={evt => {
            if (evt.key === "Enter") singleClick(evt,d)
          }}
          onClick={evt => singleClick(evt,d)}
          onDragOver={evt => {
            if (dragInfo.activeDay === d) {
              evt.preventDefault();
            }
          }}
          onDrop={evt => {
            if (dragInfo.activeDay === d) {
              drop(evt,d);
            }
          }}
          style={{
            position: "absolute",
            [lrProp]: lrVal+"px",
            top: dayLabelHeight+"px",
            height: pixelHeightPerDay+"px",
            width: pixelWidthPerDay+"px",
            backgroundColor: backgroundColor,
            border: dayBorder
          }}
        ></div>
      );
      days.push(nd);

      let dt,top;
      for (let h=1;h<24;h++) {
        dt = moment(new Date(millisDayStart)).add(h,"hour").toDate();
        top = getTop(dt,millisDayStart,millisDayStart + millisPerDay);
        nd = (
          <div key={"hs"+d+"_"+h} 
            onDragOver={evt => {
              if (dragInfo.activeDay === d) {
                evt.preventDefault();
              }
            }}
            style={{
              position: "absolute",
              [lrProp]: lrVal+"px",
              top: top+"px",
              width: pixelWidthPerDay+"px",
              height: "1px",
              backgroundColor: lineColor
            }}
          ></div>
        );
        separators.push(nd);
      }

      dt = moment(millisDayStart+nowOffset).toDate();
      top = getTop(dt,millisDayStart,millisDayStart + millisPerDay);
      nd = (
        <div key={"n"+d}
          style={{
            position: "absolute",
            [lrProp]: lrVal+"px",
            top: top+"px",
            width: pixelWidthPerDay,
            height: "2px",
            backgroundColor: lineColorNow
          }}
        ></div>
      );
      nowLine.push(nd);

    }

    let whenList = [];
    const when = this.state.when;
    if (when) {
      let r = {
        fromDate: when.start.date,
        toDate: when.end.date
      }
      if (when.duration === "allDay") {
        const start = moment(when.start.date).startOf("day");
        const end = moment(when.end.date).endOf("day");
        r.fromDate = start;
        r.toDate = end;
      }
      for (let d=0;d<7;d++) {
        if (isDaily && d > 0) break;
        let mDayStart = moment(millisDay1Start).add(d,"day").startOf("day");
        let millisDayStart = mDayStart.toDate().getTime();
        let millisDayEnd = millisDayStart + millisPerDay;
        let intersects = (r.fromDate < millisDayEnd) && (r.toDate > millisDayStart);
        if (!intersects) continue;
        let offsetLR = hourLabelWidth;
        let lrVal = offsetLR + (pixelWidthPerDay * d);
        let dt1 = new Date(r.fromDate);
        let dt2 = new Date(r.toDate);
        let y1 = getTop(dt1,millisDayStart,millisDayStart + millisPerDay);
        let y2 = getTop(dt2,millisDayStart,millisDayStart + millisPerDay);
        let h = y2 - y1;
        let sameStart = moment(r.fromDate).isSame(moment(mDayStart),"day");
        let sameEnd = moment(r.toDate).isSame(moment(mDayStart),"day");

        let nd = (
          <div id={this.componentId+"when-"+d}
            key={"w"+d+"_when"}
            role="button"
            tabIndex="0"
            data-i-res="w"
            onKeyDown={evt => wclicked(evt,d,r)}
            onClick={evt => wclicked(evt,d,r)}
            onDragOver={evt => {
              if (dragInfo.activeDay === d) {
                evt.preventDefault();
              }
            }}
            onDrop={evt => {
              if (dragInfo.activeDay === d) {
                drop(evt,d);
              }
            }}
            style={{
              position: "absolute",
              [lrProp]: lrVal+"px",
              top: y1+"px",
              height: h+"px",
              width: pixelWidthPerDay+"px",
              overflow: "hidden",
              color: whenTextColor,
              backgroundColor: whenBackgroundColor,
              border: whenBorder,
              borderRadius: "6px",
              opacity: "0.5"
            }}
          >
          </div>
        )
        whenList.push(nd);

        if (sameStart && !isOngoing) {
          let lrv = lrVal;
          nd = (
            <div id={this.componentId+"dh-top-"+d}
              key={"w"+d+"_dhTop"}
              data-i-dh-bottom="y"
              draggable
              onDragStart={evt => {
                dragInfo.r = r;
                dragInfo.activeDay = d;
                dragInfo.initialTop = y1;
                dragInfo.initialHeight = h;
                dragInfo.lastResize = 0;
                dragInfo.pos = "top";
              }}
              onDrag={evt => {
                drag(evt,d,r);
              }}
              onDragEnd={evt => {
                dragEnd(evt,d);
              }}
              onDragOver={evt => {
                if (dragInfo.activeDay === d) {
                  evt.preventDefault();
                }
              }}
              style={{
                content: "",
                position: "absolute",
                [lrProp]: lrv+"px",
                top: (y1-dragHandleHalfSize)+"px",
                height: dragHandleSize+"px",
                width: (pixelWidthPerDay / 1)+"px",
                overflow: "hidden",
                backgroundColor: dragHandleColor,
                cursor: "row-resize"
              }}
            >
            </div>
          )
          whenList.push(nd);
        }

        if (sameEnd) {
          let lrv = lrVal;
          nd = (
            <div id={this.componentId+"dh-bottom-"+d}
              key={"w"+d+"_dhBottom"}
              data-i-dh-bottom="y"
              draggable
              onDragStart={evt => {
                dragInfo.r = r;
                dragInfo.activeDay = d;
                dragInfo.initialTop = y1;
                dragInfo.initialHeight = h;
                dragInfo.lastResize = 0;
                dragInfo.pos = "bottom";
              }}
              onDrag={evt => {
                drag(evt,d,r);
              }}
              onDragEnd={evt => {
                dragEnd(evt,d);
              }}
              onDragOver={evt => {
                if (dragInfo.activeDay === d) {
                  evt.preventDefault();
                }
              }}
              style={{
                content: "",
                position: "absolute",
                [lrProp]: lrv+"px",
                top: (y1+h-dragHandleHalfSize)+"px",
                height: dragHandleSize+"px",
                width: (pixelWidthPerDay / 1)+"px",
                overflow: "hidden",
                backgroundColor: dragHandleColor,
                cursor: "row-resize"
              }}
            >
            </div>
          )
          whenList.push(nd);
        }

      }
    }

    let list = [];
    if (reservationInfo && reservationInfo.reserved && reservationInfo.reserved.length > 0) {
      for (let d=0;d<7;d++) {
        if (isDaily && d > 0) break;
        let mDayStart = moment(millisDay1Start).add(d,"day").startOf("day");
        let millisDayStart = mDayStart.toDate().getTime();
        let millisDayEnd = millisDayStart + millisPerDay;
        reservationInfo.reserved.forEach(r => {
          let intersects = (r.fromDate < millisDayEnd) && (r.toDate > millisDayStart);
          if (!intersects) return;
          let offsetLR = hourLabelWidth;
          let lrVal = offsetLR + (pixelWidthPerDay * d);
          let dt1 = new Date(r.fromDate);
          let dt2 = new Date(r.toDate);
          let y1 = getTop(dt1,millisDayStart,millisDayStart + millisPerDay);
          let y2 = getTop(dt2,millisDayStart,millisDayStart + millisPerDay);
          let h = y2 - y1;
          let dsc = r.title;
          if (isHotel) dsc = r.reservee;
          let dscNode;
          let isOriginalBooking = false;
          if (this.props.operation === "updateBookingTime" && this.props.when) {
            if (r.fromDate === this.props.when.start.date && r.toDate === this.props.when.end.date) {
              isOriginalBooking = true;
            }
          }

          if (dsc) {
            dscNode = (
              <div className="i-scheduled-item"
                role="button"
                tabIndex="0"
                data-i-res="y"
                onKeyDown={evt => rclicked(evt,d,r)}
                onClick={evt => rclicked(evt,d,r)}
                onDragOver={evt => {
                  if (isOriginalBooking && dragInfo.activeDay === d) {
                    evt.preventDefault();
                  }
                }}
                onDrop={evt => {
                  if (isOriginalBooking && dragInfo.activeDay === d) {
                    drop(evt,d);
                  }
                }}
                style={{
                  fontSize: "12px",
                  margin: "4px",
                  padding: "1px",
                  cursor: "default"
                }}
              >{dsc}</div>
            )
          }
          let nd = (
            <div key={"r"+d+"_"+r.oid}
              role="button"
              tabIndex="0"
              data-i-res="y"
              onKeyDown={evt => rclicked(evt,d,r)}
              onClick={evt => rclicked(evt,d,r)}
              onDragOver={evt => {
                if (isOriginalBooking && dragInfo.activeDay === d) {
                  evt.preventDefault();
                }
              }}
              onDrop={evt => {
                if (isOriginalBooking && dragInfo.activeDay === d) {
                  drop(evt,d);
                }
              }}
              style={{
                position: "absolute",
                [lrProp]: lrVal+"px",
                top: y1+"px",
                height: h+"px",
                width: pixelWidthPerDay+"px",
                overflow: "hidden",
                color: busyTextColor,
                backgroundColor: busyBackgroundColor,
                border: busyBorder,
                borderRadius: "6px"
              }}
            >
              {dscNode}
            </div>
          )
          list.push(nd);
        });
      }
    }

    return (
      <div className="i--week"
        style={{
          maxWidth: "auto",
          minWidth: minPanelWidth+"px",
          minHeight: minPanelHeight+"px"}}>
        <div style={{position: "relative", boxSizing:"border-box"}}>
          <div
            style={{
              position: "absolute",
            }}>
            <div
              style={{
                position: "relative"
              }}>
              {dayLabels}
            </div>
          </div>
          <div
            style={{
              position: "absolute",
              top: contentTop+"px",
              paddingTop: "10px",
              width: "100%",
              maxWidth: maxContentWidth,
              height: contentHeight,
              overflowY:"scroll",
              overflowX: "hidden"
            }}>
            <div
              style={{
                position: "relative"
              }}>
              {hourLabels}
              {days}
              {separators}
              {list}
              {whenList}
              {nowLine}
            </div>
          </div>
        </div>
      </div>
    );
  }

  scrollIntoView() {
    const nl = document.querySelectorAll("div[data-i-res='w']");
    if (nl && nl.length > 0) {
      const nd = nl[0];
      if (nd && typeof nd.scrollIntoView === "function") {
        const opts = {block: "center", inline: "nearest"};
        nd.scrollIntoView(opts);
      }
    }
  }

  showMeetingInfo(reservation) {
    const ctx = Context.getInstance();
    const { i18n, lib } = ctx;

    const reservationsDataset = ctx.aiim.datasets && ctx.aiim.datasets.reservations;
    const unitsDataset = ctx.aiim.datasets && ctx.aiim.datasets.units;
    const reservedForUsername = reservationsDataset
      ? reservation.feature.attributes[reservationsDataset.reservedForUsernameField]
      : null;
    const currentUsername = ctx.user.getUsername();
    const calendarParams = reservationsDataset && currentUsername != null && currentUsername === reservedForUsername
      ? makeEventInfo(reservationsDataset, reservation.feature, unitsDataset, this.props.item.unitFeature)
      : null;

    const levels = ctx.aiim.datasets.levels;
    let title = i18n.meetingRooms.meetingDetails;
    let dtFrom = new Date(reservation.fromDate);
    let dtTo = new Date(reservation.toDate);
    let from = lib.dojo.locale.format(dtFrom,{formatLength:"short"});
    let to = lib.dojo.locale.format(dtTo,{formatLength:"short"});
    let range = i18n.meetingRooms.rangePattern.replace("{fromDate}",from).replace("{toDate}",to);
    let orgBy = reservation.reservee && i18n.meetingRooms.organizedBy.replace("{person}",reservation.reservee);
    let unit = reservation.unitName;
    let fl;
    let ld = levels && levels.getLevelData(reservation.levelId);
    if (ld) {
      let p = i18n.meetingRooms.levelAndFacility;
      fl = p.replace("{levelName}",ld.levelName).replace("{facilityName}",ld.facilityName);
    }
    if (this.props.item.isHotel) {
      title = i18n.meetingRooms.reservationDetails;
      orgBy = reservation.reservee && i18n.meetingRooms.reservedFor.replace("{person}",reservation.reservee);
    }

    // let icsNode, icsInfo = reservation.icsInfo;
    // if (icsInfo && typeof icsInfo.href === "string") {
    //   icsNode = <IcsLink icsInfo={icsInfo} />
    // }

    // let content = (
    //   <div className="i-meeting-details">
    //     <div className="i-text-center"><strong>{reservation.title}</strong></div>
    //     <div className="i--row"><span><ClockIcon /></span><span>{range}</span></div>
    //     <div className="i--row"><span><PinIcon /></span><span>{unit}<br />{fl}</span></div>
    //     <div className="i--row"><span><UserIcon /></span><span>{orgBy}</span></div>
    //     {!!icsNode &&
    //       <div className="i-text-center i-separated">{icsNode}</div>
    //     }
    //   </div>
    // );

    const content = (
      <MeetingInformation
        range={range}
        unit={unit}
        fl={fl}
        orgBy={orgBy}
        reservation={reservation}
        calendarParams={calendarParams}
      />
    );

    let modalProps = {
      title: title,
      className: "i-modal-confirm i-modal-transparent",
      showOKCancel: false
    }
    const controller = new ModalController();
    controller.show(modalProps,content);
  }

  _onStartChanged = (date) => {
    if (!date) {
      return;
    }

    const { when } = this.state;
    const start = new Date(date).valueOf();
    when.start.date = start;

    let dtMoment = moment(date);
    let v = moment(date).startOf("week").valueOf();
    
    this.setState({
      when,
      dateMoment: dtMoment,
      startOfWeekMillis: v
    }, () => this.queryUnitSchedule());
  }

  _onEndChanged = (date) => {
    if (!date) {
      return;
    }

    const { when } = this.state;
    const end = new Date(date).valueOf();
    when.end.date = end;

    this.setState({ when });
  }

  _onCheckInOutChanged = (startDate, endDate, allDay) => {
    if (!startDate || !endDate) {
      return;
    }

    const { when } = this.state;
    const start = new Date(startDate).valueOf();
    const end = new Date(endDate).valueOf();
    if (
      !allDay || 
      !moment(start).isSame(moment(when.start.date), "day") ||
      !moment(end).isSame(moment(when.end.date), "day")
    ) {
      when.start.date = start;
      when.end.date = end;
    }
    when.duration = !!allDay ? "allDay" : null;

    let dtMoment = moment(startDate);
    let v = moment(startDate).startOf("week").valueOf();
    
    this.setState({
      when,
      dateMoment: dtMoment,
      startOfWeekMillis: v
    }, () => this.queryUnitSchedule());
  }

  _makeRangeLabel = () => {
    const lib = Context.getInstance().lib;
    const { startOfWeekMillis, isWeekly, dateMoment } = this.state;

    const currentDateNum = new Date(dateMoment).getDate();
    const startDate = new Date(startOfWeekMillis);
    const endDate = moment(startDate).add(6, "day");
    const startNum = startDate.getDate();
    const endNum = new Date(endDate).getDate();
    const dayOfWeek = lib.dojo.locale.format(new Date(dateMoment), {
      formatLength: "full",
      selector: "date",
      datePattern: "EEEE"
    });

    if (isWeekly) {
      if (endDate.isSame(startDate, "month")) {
        const month = lib.dojo.locale.format(new Date(startOfWeekMillis), { selector: "date", datePattern: "MMMM" });
        return `${month} (${startNum} - ${endNum})`;
      } else {
        const month1 = lib.dojo.locale.format(startDate, { selector: "date", datePattern: "MMMM" });
        const month2 = lib.dojo.locale.format(new Date(endDate), { selector: "date", datePattern: "MMMM" });
        return `${month1} ${startNum} - ${month2} ${endNum}`;
      }
    } else {
      return `${currentDateNum} ${dayOfWeek}`;
    }
  }

}

/* ------------------------------------------------------------ */

class MeetingInformation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popoverOpen: false
    };
  }

  _togglePopover = () => {
    this.setState({ popoverOpen: !this.state.popoverOpen });
  }

  render() {
    const i18n = Context.getInstance().i18n;
    const { range, unit, fl, orgBy, reservation, calendarParams } = this.props;
    const { popoverOpen } = this.state;

    const addToCalendarButton = (
      <button
        className={"i-button"}
        onClick={this._togglePopover}
      >
        {i18n.events.details.addToCalendar}
      </button>
    );

    const calendarSelector = (
      <div className="i-text-center i-separated">
        <CalendarSelector
          onRequestClose={this._togglePopover}
          open={popoverOpen}
          targetEl={addToCalendarButton}
          params={calendarParams}
        />
      </div>
    );

    return (
      <div className="i-meeting-details">
        <div className="i-text-center"><strong>{reservation.title}</strong></div>
        <div className="i--row"><span><ClockIcon /></span><span>{range}</span></div>
        <div className="i--row"><span><PinIcon /></span><span>{unit}<br />{fl}</span></div>
        {orgBy && <div className="i--row"><span><UserIcon /></span><span>{orgBy}</span></div>}
        {calendarParams && calendarSelector}
      </div>
    );
  }
}
